import script from "./TrendingPairs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingPairs.vue?vue&type=script&setup=true&lang=ts"

import "./TrendingPairs.vue?vue&type=style&index=0&id=129040c7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129040c7"]])

export default __exports__